import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => {
  return {
    movie: {
      padding: '10px',
    },
    links: {
      alignItems: 'center',
      fontWeight: 'bolder',
      textDecoration: 'none',
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
      },
      [theme.breakpoints.up('sm')]: {
        display: 'flex',
        flexDirection: 'column',
      },
      '&:hover': {
        cursor: 'pointer',
      },
    },
    image: {
      borderRadius: '20px',
      height: '300px',
      marginBottom: '10px',
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
        width: '100%',
      },
      '&:hover': {
        transform: 'scale(1.05)',
      },
    },
    title: {
      color: theme.palette.text.primary,
      textOverflow: 'ellipsis',
      width: '230px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      marginTop: '10px',
      marginBottom: 0,
      textAlign: 'center',
      textDecoration: 'none !important',
    },
  };
});
